// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React from "react";
import language from "../../utils/en.json";

// JSX for a general error
export const GeneralError = () => {
  return (
    <>
      {language["GENERAL.ERROR"]}
      <a
        href="https://support.augmentt.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        {language["GENERAL.CONTACT_SUPPORT"]}
      </a>
    </>
  );
};
